<div class="chunk-tile" [class.has-actions]="showActions">
  <!-- Header Row: Title on Left, Actions on Right -->
  <div class="chunk-header-row" *ngIf="title || showActions">
    <div class="chunk-title-wrap" *ngIf="title">
      <span *ngIf="titleIcon" class="material-symbols-outlined chunk-title-icon"
        [style.color]="titleIcon?.colorWhenActive"
        [style.fontSize]="titleIcon?.size || '16px'">
        {{ titleIcon?.icon }}
      </span>
      <span class="chunk-title">
        {{ title }}
        <span *ngIf="unit" class="chunk-unit">({{ unit }})</span>
      </span>
    </div>
    <div class="chunk-actions" *ngIf="showActions">
      <lib-insight-actions
        [uniqueIdentifier]="actionsId"
        [isAdmin]="isAdmin"
        [tag]="tag"
        [inBucket]="inBucket"
        (viewTagInsight)="viewTagInsight.emit()"
        (toggleTrend)="toggleTrend.emit()">
      </lib-insight-actions>
    </div>
  </div>

  <!-- Progress Bar Row: Segments Track + Floating Value Badge -->
  <div class="chunk-progress-row"
       [style.--pct]="pct"
       [style.--badge-size.px]="badgeSize">
    <span *ngIf="fractionLabel" class="chunk-fraction-label left">E</span>
    <div class="chunk-track-wrapper">
      <div class="chunk-track">
        <div *ngFor="let seg of segments; trackBy: trackByIndex"
          class="chunk-seg"
          [class.is-active]="seg.active"
          [style.backgroundColor]="seg.active ? seg.color : ''">
        </div>
      </div>
      <div *ngIf="showBadge" class="chunk-value-badge" [ngStyle]="badgeStyle" aria-hidden="true">
        {{ badgeLabel }}
      </div>
    </div>
    <span *ngIf="fractionLabel" class="chunk-fraction-label right">F</span>
    <div *ngIf="!showBadge && showPill" class="chunk-value-pill">
      {{ badgeLabel }}
    </div>
  </div>

  <!-- Meta / Timestamp Row -->
  <div class="chunk-meta-row" *ngIf="showTimestamp">
    <span *ngIf="tag?.LastObs?.DateInMilliseconds; else metricNotSupported">
      {{ tag?.LastObs?.DateInMilliseconds | mobileTimezoneDate: 'medium' : tag?.SiteId }}
    </span>
    <ng-template #metricNotSupported>
      <span>Metric Not Supported</span>
    </ng-template>
  </div>
</div>
